import { z } from "zod";

export const enabledIssuerPageBoxes = z
  .object({
    acoes: z.array(
      z.union([
        z.literal("ABOUT_BOX"),
        z.literal("CARDS"),
        z.literal("GOVERNANCE_BOX"),
        z.literal("EVENTS_BOX"),
        z.literal("OPERATING_SEGMENTS_BOX"),
        z.literal("LIQUIDITY_BOX"),
        z.literal("QUOTES_BOX"),
        z.literal("FINANCIALS_BOX"),
        z.literal("HIGHLIGHTS_BOX"),
        z.literal("DISCUSSIONS_BOX"),
      ]),
    ),
    stocks: z.array(
      z.union([
        z.literal("ABOUT_BOX"),
        z.literal("CARDS"),
        z.literal("GOVERNANCE_BOX"),
        z.literal("EVENTS_BOX"),
        z.literal("OPERATING_SEGMENTS_BOX"),
        z.literal("LIQUIDITY_BOX"),
        z.literal("QUOTES_BOX"),
        z.literal("FINANCIALS_BOX"),
        z.literal("KPIS_BOX"),
        z.literal("HIGHLIGHTS_BOX"),
        z.literal("DISCUSSIONS_BOX"),
      ]),
    ),
    fiis: z.array(
      z.union([
        z.literal("ABOUT_BOX"),
        z.literal("CARDS"),
        z.literal("ASSETS_BOX"),
        z.literal("LIQUIDITY_BOX"),
        z.literal("QUOTES_BOX"),
        z.literal("FINANCIALS_BOX"),
        z.literal("DISCUSSIONS_BOX"),
      ]),
    ),
  })
  .default({
    acoes: [
      "ABOUT_BOX",
      "CARDS",
      "GOVERNANCE_BOX",
      "EVENTS_BOX",
      "OPERATING_SEGMENTS_BOX",
      "LIQUIDITY_BOX",
      "QUOTES_BOX",
      "FINANCIALS_BOX",
      "HIGHLIGHTS_BOX",
      "DISCUSSIONS_BOX",
    ],
    stocks: [
      "ABOUT_BOX",
      "CARDS",
      "GOVERNANCE_BOX",
      "EVENTS_BOX",
      "OPERATING_SEGMENTS_BOX",
      "LIQUIDITY_BOX",
      "QUOTES_BOX",
      "FINANCIALS_BOX",
      "HIGHLIGHTS_BOX",
      "DISCUSSIONS_BOX",
    ],
    fiis: ["ABOUT_BOX", "CARDS", "ASSETS_BOX", "LIQUIDITY_BOX", "QUOTES_BOX", "FINANCIALS_BOX", "DISCUSSIONS_BOX"],
  })
  .describe("The User's enabled boxes on the Issuer page");
